import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IconBase from '@blade-sxp/tools/pages/one-one/components/icon-base.vue';
import IconSideBase from '@blade-sxp/tools/pages/one-one/components/icon-side-base.vue';
import Loading from '@blade-sxp/tools/components/loading.vue';
import Result from '@blade-sxp/tools/components/result.vue';
import { Status } from '@blade-sxp/tools/interfaces';
import colors from '@/styles/color.scss';
let Divide = class Divide extends Vue {
    status;
    percent;
    Status = Status;
    color = colors['color-prepare-status'];
    onStatusChange(val) {
        if (val === Status.Prepare) {
            this.color = colors['searchYellow'];
        }
        else {
            this.color = colors['color-prepare-status'];
        }
    }
};
__decorate([
    Prop(Number)
], Divide.prototype, "status", void 0);
__decorate([
    Prop({ default: '0', type: String })
], Divide.prototype, "percent", void 0);
__decorate([
    Watch('status', { immediate: true })
], Divide.prototype, "onStatusChange", null);
Divide = __decorate([
    Component({
        name: 'divide',
        components: { IconBase, IconSideBase, Loading, Result },
    })
], Divide);
export default Divide;
